/* eslint-disable consistent-return */
/* eslint-disable no-return-assign */
import axios from 'axios';
import encryptStorage from './encryption';
import { apiBaseUrl } from './lib';

const token = encryptStorage.getItem('token') || '';

const headers = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: token,
  },
};

const authAxios = axios.create({
  baseURL: apiBaseUrl(`${process.env.REACT_APP_API}/auth`),
  ...headers,
});

const dataAxios = axios.create({
  baseURL: apiBaseUrl(`${process.env.REACT_APP_API}/data`),
  ...headers,
});

const transactionsAxios = axios.create({
  baseURL: apiBaseUrl(`${process.env.REACT_APP_API}/transactions`),
  ...headers,
});

const collectionsAxios = axios.create({
  baseURL: apiBaseUrl(`${process.env.REACT_APP_API}/collections`),
  ...headers,
});

const gatewayAxios = axios.create({
  baseURL: apiBaseUrl(`${process.env.REACT_APP_API}/gateway`),
  ...headers,
});

const fdsAxios = axios.create({
  baseURL: apiBaseUrl(`${process.env.REACT_APP_API}/fds`),
  ...headers,
});

const unicornAxios = axios.create({
  baseURL: apiBaseUrl(process.env.REACT_APP_UNICORN_API),
  ...headers,
});

const logsAxios = axios.create({
  baseURL: apiBaseUrl(`${process.env.REACT_APP_API}/logs`),
  ...headers,
});

const aggregateAxios = axios.create({
  baseURL: apiBaseUrl(process.env.REACT_APP_AGGREGATE_API),
  ...headers,
});


const axiosInstances = [
  authAxios,
  dataAxios,
  transactionsAxios,
  collectionsAxios,
  gatewayAxios,
  fdsAxios,
  unicornAxios,
  logsAxios,
  aggregateAxios
];

// axiosInstances.map((instance) => instance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response.status !== 401) {
//       return new Promise((_, reject) => {
//         reject(error);
//       });
//     }
//     encryptStorage.removeItem('token');
//     encryptStorage.removeItem('user');
//     return window.location.href = '/signin';
//   },
// ));

export { dataAxios };
export { transactionsAxios };
export { collectionsAxios };
export { gatewayAxios };
export { fdsAxios };
export { unicornAxios };
export { logsAxios };
export { aggregateAxios };
export default authAxios;
